import { handleFormSubmit, useAuth, useRequest } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import Form from '../../components/Form'
import fields, { ContactAdvancedFormData } from './fields'

interface Props {
  afterSubmit?: (data: any) => void
}

const ContactAdvancedForm: React.FC<Props> = ({ afterSubmit }) => {
  const { request } = useRequest()
  const { user } = useAuth()
  const [selectFields, setSelectFields] = useState(fields)
  const [realtiesOptions, setRealtiesOptions] = useState<any[]>([])

  useEffect(() => {
    let mounted = true
    request({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/realties`,
    }).then(({ data }) => {
      if (mounted) {
        if (data && data.data) {
          const options = [
            {
              label: 'Seleccione Imóveis',
              value: '',
            },
          ]

          data.data.map((item: { registry_office: any, id: any }) => {
            const option = {
              label: item.registry_office,
              value: item.id,
            }
            options.push(option)
            return option
          })
          setTimeout(() => {
            setRealtiesOptions(options)
          }, 0)
        }
      }
    }).catch(() => {

    })
    return () => {
      mounted = false
    }

  }, [])

  useEffect(() => {

    const formFieldsIn = fields
    formFieldsIn.forEach((field, index) => {
      if (field.name === 'realties') {
        formFieldsIn[index].data = {
          label: 'Seleccione Imóveis',
          options: realtiesOptions,
        }
      }
    })

    setTimeout(() => {
      setSelectFields(formFieldsIn)
    }, 0)

  }, [realtiesOptions])

  return (
    <Form<ContactAdvancedFormData>
      buttonLabel="ENVIAR MENSAGEM"
      initialValues={{
        name: user.name,
        email: user.email,
        phone: user.phone,
        message: '',
      }}
      fields={selectFields}
      onSubmit={(data, form) => handleFormSubmit({
        request: request({
          method: 'POST',
          url: `${process.env.REACT_APP_API_URL}/chat/contact`,
          data,
        }),
        onValidationErrors: () => toast.error('Erros de validacao.'),
        onSuccess: ({ data }) => {
          setTimeout(() => {
            form.reset()
          }, 1)
          toast.success('Mensagem enviada com sucesso')
          if (afterSubmit) {
            afterSubmit(data)
          }
        },
        onFailure: (data) => {
          toast.error(data.message)
        },
      })}
    />
  )
}

export default ContactAdvancedForm
